import styled from "styled-components"
import { TeamImgCard, TeamImgProps } from "../../atoms"

interface ITeamImgProps {
  items: Array<TeamImgProps>
}

const Wrapper = styled.div`
  width: fit-content;
  max-width: 100%;
  margin: auto;

  @media (max-width: 900px) {
    width: 100%;
  }
`

const GridStyle = styled.div`
  display: grid;
  grid-template-columns: repeat(2, auto);
  gap: 12px;
  place-items: center;
  padding: 0;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, auto);
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(4, auto);
    gap: 20px;
    > *:nth-child(1) {
      grid-column: 2;
      grid-row: 1;
    }

    > *:nth-child(2) {
      grid-column: 3;
      grid-row: 1;
    }

    > *:nth-child(3) {
      grid-column: 1;
      grid-row: 2;
    }

    > *:nth-child(4) {
      grid-column: 2;
      grid-row: 2;
    }

    > *:nth-child(5) {
      grid-column: 3;
      grid-row: 2;
    }

    > *:nth-child(6) {
      grid-column: 4;
      grid-row: 2;
    }
  }
`

const EmployeeInformationGrid: React.FC<ITeamImgProps> = ({ items }) => {
  return (
    <Wrapper>
      <GridStyle>
        {items.map((item, index) => (
          <TeamImgCard
            key={index}
            image={item.image}
            name={item.name}
            position={item.position}
          />
        ))}
      </GridStyle>
    </Wrapper>
  )
}

export { EmployeeInformationGrid }
